/**
 * @generated SignedSource<<e2724bff580f137b6ebcf713cca0c51e>>
 * @relayHash daa192bdcc2dd32f701b96b9020d5742
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 18e13f5df34afb98c5605d03f6bb2a5f0859d934261b85e22278e5f36862f072

import type { ConcreteRequest } from 'relay-runtime';
export type useContentTypeCreationEligibilityQuery$variables = {
  includeEligibility: boolean;
  spaceKey: string;
};
export type useContentTypeCreationEligibilityQuery$data = {
  readonly space: {
    readonly key: string | null;
    readonly operations?: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType: string | null;
    } | null> | null;
    readonly spaceTypeSettings: {
      readonly enabledContentTypes?: {
        readonly isDatabasesEnabled: boolean;
        readonly isWhiteboardsEnabled: boolean;
      };
    };
  } | null;
};
export type useContentTypeCreationEligibilityQuery = {
  response: useContentTypeCreationEligibilityQuery$data;
  variables: useContentTypeCreationEligibilityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeEligibility"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v2 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "spaceKey"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "key"
},
v4 = {
  "concreteType": "SpaceTypeSettings",
  "kind": "LinkedField",
  "name": "spaceTypeSettings",
  "plural": false,
  "selections": [
    {
      "condition": "includeEligibility",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "EnabledContentTypes",
          "kind": "LinkedField",
          "name": "enabledContentTypes",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isWhiteboardsEnabled"
            },
            {
              "kind": "ScalarField",
              "name": "isDatabasesEnabled"
            }
          ]
        }
      ]
    }
  ]
},
v5 = {
  "condition": "includeEligibility",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "OperationCheckResult",
      "kind": "LinkedField",
      "name": "operations",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "operation"
        },
        {
          "kind": "ScalarField",
          "name": "targetType"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useContentTypeCreationEligibilityQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useContentTypeCreationEligibilityQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "daa192bdcc2dd32f701b96b9020d5742",
    "id": "18e13f5df34afb98c5605d03f6bb2a5f0859d934261b85e22278e5f36862f072",
    "metadata": {},
    "name": "useContentTypeCreationEligibilityQuery",
    "operationKind": "query",
    "text": "query useContentTypeCreationEligibilityQuery($spaceKey:String!,$includeEligibility:Boolean!){space(key:$spaceKey){key,spaceTypeSettings{enabledContentTypes@include(if:$includeEligibility){isWhiteboardsEnabled,isDatabasesEnabled}},operations@include(if:$includeEligibility){operation,targetType},id}}"
  }
};
})();

(node as any).hash = "9e07144ab47d8e6be636cfe65e8a2de4";

export default node;
